import { render, staticRenderFns } from "./DesignProductList.vue?vue&type=template&id=2905bac6&"
import script from "./DesignProductList.vue?vue&type=script&lang=js&"
export * from "./DesignProductList.vue?vue&type=script&lang=js&"
import style0 from "./DesignProductList.vue?vue&type=style&index=0&id=2905bac6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports